<router-outlet name="retroalimentacion"></router-outlet>

<ng-template #loadingUnidad>
  <mat-spinner></mat-spinner>
</ng-template>

<mat-tab-group [selectedIndex]="activeTab"
  (selectedIndexChange)="onChangeTab($event)"
  *ngIf="unidad; else loadingUnidad">

  <mat-tab label="METAS">
    <ng-container>
      <unidad-etapas-metas
        [_metas]="unidad.metas"
        [categorias]="categorias"
        [unidadID]="unidad.id"
        [areas]="unidad.areas">
      </unidad-etapas-metas>
    </ng-container>
    <!-- 
    <div>
      <button mat-fab color="primary" style="position: fixed; right: 2%; bottom: 2%; z-index: 500"
              [mat-menu-trigger-for]="menuMetas">
        <mat-icon>add</mat-icon>
      </button>
      <mat-menu [overlapTrigger]="true"
      yPosition="below" #menuMetas="matMenu">
      <button mat-menu-item (click)="abrirDialog('meta')">
        Crear meta
      </button>
      <button mat-menu-item (click)="importar('metas')">
        Importar metas
      </button>
      </mat-menu>
    </div>
    -->
  </mat-tab>

  <mat-tab label="EVIDENCIAS">
    <unidad-etapas-evidencias
      [_evidencias]="unidad.evidencias"
      [unidadID]="unidad.id"
      [materias]="unidad.materias"
      [isFamilia]="false"
      [areas]="unidad.areas"
      [tiposEvidencias]="unidad['eventosCategoria']"
      [_unidad]="unidad"
    ></unidad-etapas-evidencias>

    <div>
      <button mat-fab color="primary" 
        style="position: fixed; right: 2%; bottom: 2%; z-index: 500"
        [mat-menu-trigger-for]="menuEvidencias">
        <mat-icon>add</mat-icon>
      </button>
      <mat-menu [overlapTrigger]="true"
                yPosition="below" #menuEvidencias="matMenu">
        <button mat-menu-item (click)="abrirDialog('evento')">
          Crear evidencia
        </button>
        <button mat-menu-item (click)="importar('eventos')">
          Importar evidencias
        </button>
      </mat-menu>
    </div>
  </mat-tab>

  <mat-tab label="EVENTOS DE APRENDIZAJE">
    <unidad-eventos-aprendizaje 
      [_eventos]="unidad.eventos"
      [fechaInicio]="unidad.fechaInicia"
      [fechaFin]="unidad.fechaFin"
      [unidadID]="unidad.id"
      [areas]="unidad.areas"
      [unidad]="unidad"
    ></unidad-eventos-aprendizaje>
    <!--<unidad-eventos-calendario-->
    <!--[eventos]="unidad.eventos"-->
    <!--[fechaInicio]="unidad.fechaInicia"-->
    <!--[fechaFin]="unidad.fechaFin"></unidad-eventos-calendario>-->
    <div>
      <button mat-fab color="primary" 
        style="position: fixed; right: 2%; bottom: 2%; z-index: 500"
        [mat-menu-trigger-for]="menuEventos">
        <mat-icon>add</mat-icon>
      </button>
      <mat-menu [overlapTrigger]="true"
        yPosition="below" #menuEventos="matMenu">
        <button mat-menu-item (click)="abrirDialog('evento')">
          Crear evento de aprendizaje
        </button>
        <button mat-menu-item (click)="importar('eventos')">
          Importar eventos de aprendizaje
        </button>
      </mat-menu>
    </div>
  </mat-tab>
  <mat-tab label="PROFILE">
    <div *ngIf="loadRubrica">
      <rubrica-unidad 
        [unidadID]="unidad.id" 
        [unidadTitle]="unidad.nombre" 
        [areas]="unidad.areas">
      </rubrica-unidad>
    </div>
  </mat-tab>
  <mat-tab label="INFORMACIÓN BÁSICA">
    <ng-template mat-tab-label>
      <mat-icon>settings</mat-icon>
    </ng-template>
    <ng-template matTabContent>
      <div *ngIf="showFormThrobber">
        <mat-spinner></mat-spinner>
      </div>
    <div *ngIf="enEdicion">
      <unidad-form 
        [unidad]="unidad" 
        [materias]="materiasPeriodo" 
        [profesores]="profesores"
        [_periodos]="periodos"
        (isDirty)="setDirty($event)" 
        (formLoaded)="setThrobberVisibility(!$event)">
      </unidad-form>
    </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="CLASES PERDIDAS">
    <ng-template mat-tab-label>
      <mat-icon>report_problem</mat-icon>
    </ng-template>
    <ng-template matTabContent>
      <!-- <app-clase-perdida></app-clase-perdida> -->
      <app-clase-perdida-shell></app-clase-perdida-shell>
    </ng-template>
  </mat-tab>
</mat-tab-group>
<glm-modal [componentData]="modalData"></glm-modal>
